import { render, staticRenderFns } from "./onebox-loginsharelink.vue?vue&type=template&id=679c9e01&"
import script from "./onebox-loginsharelink.vue?vue&type=script&lang=js&"
export * from "./onebox-loginsharelink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports